import { ReactElement } from "react";

import getClosestDay from "@/directory/utils/getClosestDay";
import getRemainingDays from "@/directory/utils/getRemainingDays";
import { cellExpirationCss } from "../Cells.style";

interface CellExpirationProps {
  cell?: { value: string[] };
  limit?: number;
  days?: number | null;
}

const CellExpiration = ({
  cell,
  limit,
  days,
}: CellExpirationProps): ReactElement => {
  const remainingDays =
    days !== undefined ? days : getRemainingDays(getClosestDay(cell?.value));
  const expirationSuccesfullyFound =
    remainingDays !== null && remainingDays !== undefined;

  if (expirationSuccesfullyFound) {
    return (
      <span css={cellExpirationCss(remainingDays, limit)}>
        {remainingDays} days
      </span>
    );
  }

  return <span>-</span>;
};

export default CellExpiration;
